/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_LanguageInputs */

const en_user_language = /** @type {(inputs: User_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const ja_user_language = /** @type {(inputs: User_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語`)
};

const fr_user_language = /** @type {(inputs: User_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const de_user_language = /** @type {(inputs: User_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {User_LanguageInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_language = /** @type {((inputs?: User_LanguageInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_LanguageInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_language(inputs)
	if (locale === "ja") return ja_user_language(inputs)
	if (locale === "fr") return fr_user_language(inputs)
	return de_user_language(inputs)
});